import { extractNumber } from '@cred/shared/utils'

export const minMaxLoanAmount = value => {
  const numberValue = extractNumber(value)
  let error

  if (numberValue < 1000 || numberValue > 100000) {
    error = 'Please enter an amount between $1,000 and $100,000'
  }

  return error
}
